import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
    setIsMenuOpen(false);
  };

  const navigationItems = [
    { label: 'Home', id: 'hero' },
    { label: 'Untuk Driver', id: 'driver' },
    { label: 'Untuk Merchant', id: 'merchant' },
    { label: 'Cara Kerja', id: 'how-it-works' },
    { label: 'Tentang', id: 'about' },
    { label: 'Kontak', id: 'contact' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md z-50 border-b border-slate-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_868e5e9c-7cb1-4485-87f4-7a4e3322b781/artifacts/lyr3d8vs_salinguntung_02.1b7e0472.svg" 
               alt="SalingUntung - Platform Digital Ekosistem Pariwisata Indonesia | Driver Wisata & Merchant" 
              className="h-8 md:h-10 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigationItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-slate-700 hover:text-[#2D9CDB] transition-colors duration-200 font-medium"
              >
                {item.label}
              </button>
            ))}
            <Link
              to="/merchants"
              className="text-slate-700 hover:text-[#2D9CDB] transition-colors duration-200 font-medium"
            >
              Merchant
            </Link>
          </nav>

          {/* CTA Buttons - Desktop */}
          <div className="hidden lg:flex items-center space-x-3">
            <Button
              variant="outline"
              onClick={() => window.open('https://mitra.salinguntung.com', '_blank')}
              className="border-[#2D9CDB] text-[#2D9CDB] hover:bg-[#2D9CDB] hover:text-white transition-all duration-300"
            >
              Daftar Driver
            </Button>
            <Button
              onClick={() => window.open('https://merchant.salinguntung.com', '_blank')}
              className="bg-slate-900 hover:bg-slate-800 text-white transition-all duration-300"
            >
              Daftar Merchant
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors duration-200"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6 text-slate-700" />
            ) : (
              <Menu className="h-6 w-6 text-slate-700" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-slate-200 bg-white/95 backdrop-blur-md">
            <nav className="flex flex-col space-y-3">
              {navigationItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-left px-4 py-2 text-slate-700 hover:text-[#2D9CDB] hover:bg-slate-50 rounded-lg transition-all duration-200 font-medium"
                >
                  {item.label}
                </button>
              ))}
              <Link
                to="/merchants"
                onClick={() => setIsMenuOpen(false)}
                className="text-left px-4 py-2 text-slate-700 hover:text-[#2D9CDB] hover:bg-slate-50 rounded-lg transition-all duration-200 font-medium"
              >
                Merchant
              </Link>
              <div className="flex flex-col space-y-3 px-4 pt-4 border-t border-slate-200">
                <Button
                  variant="outline"
                  onClick={() => window.open('https://mitra.salinguntung.com', '_blank')}
                  className="w-full border-[#2D9CDB] text-[#2D9CDB] hover:bg-[#2D9CDB] hover:text-white transition-all duration-300"
                >
                  Daftar Driver
                </Button>
                <Button
                  onClick={() => window.open('https://merchant.salinguntung.com', '_blank')}
                  className="w-full bg-slate-900 hover:bg-slate-800 text-white transition-all duration-300"
                >
                  Daftar Merchant
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;